export function LoadingState({ label = "Reading the button" }: { label?: string }) {
  return (
    <div className="loading-state" role="status" aria-live="polite">
      <span className="loading-bar" />
      <span>{label}</span>
    </div>
  );
}
